// Floating WhatsApp + Enquiry buttons
import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, FileText } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const FloatingActions = () => {
  const { site } = useSite();
  const waPhone = (site?.phone || "").replace(/[^0-9]/g, "");
  return (
    <>
      <a
        href={`https://wa.me/${waPhone}?text=Hi%20Jhalani%20Tools,%20I'd%20like%20to%20enquire%20about`}
        target="_blank"
        rel="noopener noreferrer"
        className="jt-fab bottom-24 bg-[#25D366]"
        aria-label="WhatsApp us"
        data-testid="floating-whatsapp"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <Link
        to="/contact"
        className="jt-fab bottom-6 bg-[var(--jt-primary)]"
        aria-label="Send enquiry"
        data-testid="floating-enquiry"
      >
        <FileText className="w-6 h-6" />
      </Link>
    </>
  );
};

export default FloatingActions;
